import { fetchSinToken, fetchSinTokenMultipleFile } from "../../helpers/fetch";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { startAlerta } from "../ui/alertas";
import { startFetch } from "../../services/fetch/startFetch";
import { TAMANO_IMAGENES } from "../../utils/constants";
import { fileSize } from "../../helpers/filesFunctions";

export const sendValuesAfiliacionWeb = (data, handleNext) =>
    async (dispatch) => {
        dispatch(startSpinner());
        try {
            const response = await fetchSinToken(`AfiliacionesWeb`, data, 'POST');
            const body = await response.json();
            if (response.ok) {
                dispatch(startAlerta(`Envio Exitoso`, 'success', 'La información fue cargada correctamente'));
                handleNext(body)
                dispatch(finishSpinner());
            } else {
                throw body
            }
        } catch (error) {
            dispatch(finishSpinner())
            dispatch(startAlerta("Error al guardar la información", "warning", `¡Error!`));
        }
    }

export const uploadDocumentacionAfiliacionWeb = (files, idTipoDoc, idSolicitud, setearValor) =>
    async (dispatch) => {
        if (files?.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
            const formData = new FormData();
            formData.append("files", files);
            dispatch(startFetch(
                () => fetchSinTokenMultipleFile(`AfiliacionesWeb/Documentacion/${idTipoDoc}/${idSolicitud}`, formData),
                (response) => {
                    setearValor("documentacion", response)
                    dispatch(
                        startAlerta(
                            `Archivo Cargado Correctamente`,
                            'success',
                            'Comando Exitoso',
                        ),
                    )
                })
            );
        } else {
            dispatch(
                startAlerta(
                    `El archivo no puede ser mayor a: ${fileSize(
                        TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS
                    )} y el mismo tiene: ${fileSize(files?.size)}`,
                    "info"
                )
            );
        }
    }

export const removeDocumentacionAfiliacionWeb = (id, setearValor, formValues) =>
    async (dispatch) => {
        dispatch(startFetch(
            () => fetchSinToken(`AfiliacionesWeb/Documentacion/${id}`, {}, "DELETE"),
            () => {
                setearValor("documentacion", formValues.documentacion.filter(x => x.id !== id))
                dispatch(startAlerta(`Documentación Eliminada`, 'success', 'Comando Exitoso'));
            })
        );
    }

export const getTiposDocumentacionAfiliadoWeb = (setTiposDocumentacion) =>
    async (dispatch) => {
        dispatch(startFetch(
            () => fetchSinToken(`TiposDocumentacionAfiliacionesWeb`),
            (response) => {
                setTiposDocumentacion(response)
            })
        );
    }
